import { useEffect, useState } from 'react'

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  )
  const [since, setSince] = useState<number | null>(null)

  useEffect(() => {
    const goOnline = () => {
      setIsOnline(true)
      setSince(Date.now())
    }
    const goOffline = () => {
      setIsOnline(false)
      setSince(Date.now())
    }

    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)
    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  return { isOnline, since }
}

